<template>
  <div :class="$style.conditionRow">
    <div>
      {{ inclusionText }}
    </div>

    <div :class="$style.selectWrapper">
      <Select
        :data-test-id="$testId('conditionSelector')"
        name="condition"
        :options="conditions"
        placeholder="Select Condition"
        :value="selectedCondition.value"
        @input="selectCondition"
      />
    </div>

    <component
      :is="selectedCondition.component"
      :menuOptions="menuOptions"
      :name="name"
      :value="initialValue"
      @input="handleInput"
    />

    <ButtonDelete
      :class="$style.buttonDelete"
      :data-test-id="$testId('delete')"
      @click="deleteCondition"
    />
  </div>
</template>

<script>
import { size } from 'lodash';

import { ButtonDelete, Select } from '@jumpcloud/ui-components';

export default {
  name: 'ConditionRow',

  components: {
    ButtonDelete,
    Select,
  },

  props: {
    allOptions: {
      type: Object,
      default: () => ({}),
    },
    inclusion: {
      type: String,
      required: true,
    },
    menuOptions: {
      type: Array,
      default: () => ([]),
    },
    name: {
      type: String,
      required: true,
    },
    selections: {
      type: Array,
      default: () => ([]),
    },
    value: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    conditions() {
      const { key, label, value } = this.selectedCondition;

      return this.name === 'template'
        ? this.menuOptions
        : [{ key, name: label, value }, ...this.menuOptions];
    },

    inclusionText() {
      const index = this.selections.indexOf(this.name);
      const conjunctionText = this.inclusion === 'all' ? 'And' : 'Or';

      return index === 0 ? 'When' : conjunctionText;
    },

    initialValue() {
      // Check incoming value for object keys
      // If empty {} pass undefined so child row component uses default prop value
      return size(this.value) ? this.value : undefined;
    },

    selectedCondition() {
      return this.allOptions[this.name];
    },
  },

  methods: {
    deleteCondition() {
      this.$emit('delete', this.name);
    },

    // Emit model data from child component (operator & value)
    handleInput(model) {
      this.$emit('input', model);
    },

    selectCondition(value) {
      this.$emit('change', value);
    },
  },
};
</script>

<style module>
.conditionRow {
  align-items: baseline;
  display: grid;
  gap: 1em;
  grid-template-columns: 8% 1fr 2fr 4%;
  margin-bottom: var(--vertical-margin);
}

.buttonDelete {
  align-self: start;
}

.selectWrapper {
  --input-wrapper-width: auto;
  --input-wrapper-min-width: 10ch;
}
</style>
